import { createStore } from 'vuex';
import lite from './modules/lite';

export default createStore({
      modules: {
            lite,
      },
      state: {
            // Define your state here
      },
      mutations: {
            // Define your mutations to modify the state
      },
      actions: {
            // Define any actions that should commit mutations
      },
      getters: {
            // Define any getters to access your state
      },
});
